import * as React from 'react';
export const creditSvg = React.forwardRef(function creditSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 11.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM8 13A6.5 6.5 0 1 0 8 0a6.5 6.5 0 0 0 0 13ZM.75 15a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 0 1.5h-13A.75.75 0 0 1 .75 15ZM8.752 3.39a.85.85 0 0 0-1.504 0l-.634 1.202-1.34.232a.85.85 0 0 0-.465 1.43l.948.975-.194 1.346a.85.85 0 0 0 1.217.884l1.22-.6 1.22.6a.85.85 0 0 0 1.217-.884l-.194-1.346.948-.975a.85.85 0 0 0-.465-1.43l-1.34-.232-.634-1.203ZM7.595 5.303 8 4.536l.405.768a.85.85 0 0 0 .607.441l.856.148-.605.623a.85.85 0 0 0-.232.713l.124.86-.78-.383a.85.85 0 0 0-.75 0l-.78.383.124-.86a.85.85 0 0 0-.232-.713l-.605-.623.856-.148a.85.85 0 0 0 .607-.44Z',
    }),
  );
});
creditSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var credit = {
  category: 'icon',
  colorable: true,
  name: 'credit',
  svg: creditSvg,
};
